//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TheMask } from 'vue-the-mask'

export default {
  components: { TheMask },
  computed: {
    token() {
      return this.$store.state.userToken
    },
    user() {
      return this.$store.state.activeUser
    },
    fullName() {
      return `${this.$store.state.activeUser.first_name} ${this.$store.state.activeUser.last_name}`
    },
    email() {
      return this.$store.state.activeUser.email
    },
    cart() {
      return this.$store.state.activeOrder
    },
    loyaltyAvailable() {
      return this.$store.state.faveLocationLoyalty
    }
  },
  data() {
    return {
      // Uncomment below when all locations are ready to be tested
      //
      // loyalty: false,
      ready: false,
      blockCss: 'w-full lg:w-1/2 p-2 lg:px-8',
      fieldCss: 'w-full block border p-3 text-lg mb-2',
      fieldCssError: 'w-full block border border-red text-red p-3 text-lg mb-2',
      userData: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        // password: null,
        // confirmPassword: null
      },
      errors: []
    }
  },
  async asyncData({ $storyblok, params }) {
    const page = await $storyblok.getPage('pages/account')
    return {
      page: page
    }
  },
  head() {
    return this.$metadata(this.page)
  },
  async mounted() {
    if (!this.user) {
      this.$router.push('/signin')
    }
    if (this.user.favelocations.length > 0) {
      let location = await this.$api.getLoaction(this.user.favelocations[0].store_num)
      this.$store.commit('setFaveLocationLoyalty', location.loyalty ? location.loyalty : false)
    }
    this.$store.commit('setPage', this.page)
    if(process.client) {
      this.ready = true
      // console.log(this.user, this.token)
      if(!this.user && !this.token) {
        this.$router.push('/signin')
      } else {
        // console.log(this.user)
        if(!this.user || !this.user.addresses) {
          this.$store.commit('setLoading', true)
          let user = await this.$api.getMemberProfile()
          this.$store.commit('setLoading', false)
          if(user) {
            this.$store.commit('setActiveUser', user)
          } else {
            this.$store.commit('setActiveUser', null)
            this.$store.commit('setActiveOrder', null)
            this.$store.commit('setUserToken', null)
            this.$router.push('/signin')
          }
        }
        let userData = {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone: this.user.phone == 'null' ? null : this.user.phone
        }

        if(this.user.addresses) {
          this.user.addresses.map(a => {
            if(a.default == true) {
              userData.address = a.address
              userData.city = a.city
              userData.zip = a.zip
            }
          })
        }

        this.userData = userData
      }
    }
  },
  methods: {
    goToOptIn() {
      this.$router.push('/account/perks#join')
    },
    async removePayment(id) {
      this.$store.commit('setLoading', true)
      let payments = await this.$api.deletePayment(id)
      this.$store.commit('setLoading', false)
      let user = JSON.parse(JSON.stringify(this.user))
      user.payments = []
      this.$store.commit('setActiveUser', user)
    },
    async removeAddress(id, i) {
      this.$store.commit('setLoading', true)
      let addresses = await this.$api.deleteAddress(id)
      this.$store.commit('setLoading', false)
      let user = JSON.parse(JSON.stringify(this.user))
      user.addresses.splice(i, 1)
      this.$store.commit('setActiveUser', user)
    },
    async removeFaveLocation(l, i) {
      this.$store.commit('setLoading', true)
      let faves = await this.$api.deleteFaveLocation(l.menu_id)
      this.$store.commit('setLoading', false)
      this.$store.commit('setFaveLocationLoyalty', false)
      let user = JSON.parse(JSON.stringify(this.user))
      user.favelocations.splice(i, 1)
      this.$store.commit('setActiveUser', user)
      this.$store.commit('setFaveLocationSelector', true)
    },
    async updateAccount() {
      // window.location = 'https://prkmc.fishbowlcloud.com/enduserportal/index.html#/profile'
      let errors = []
      let sendUser = {
        id: this.user.id
      }
       Object.keys(this.userData).map(f => {
         let v = this.userData[f]
        //  console.log(f, v)
         switch(f) {
            case 'first_name':
              if(v.match(/^[a-zA-Z]+/)) {
                sendUser.first_name = v
              } else {
                errors.push('first_name')
              }
              break
            case 'last_name':
              if(v.match(/^[a-zA-Z]+/)) {
                sendUser.last_name = v
              } else {
                errors.push('last_name')
              }
              break
            case 'email':
              if(v.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                sendUser.email = v
              } else {
                errors.push('email')
              }
              break
            // case 'phone':
            //   if(!v || !v.match(/^\d{10}$/)) {
            //     errors.push('phone')
            //   } else {
            //     sendUser.phone = v
            //   }
            //   break
            // case 'password':
            //   if(v != null) {
            //     if(v.length < 8) {
            //       errors.push('password')
            //     } else {
            //       sendUser.password = v
            //     }
            //     console.log('checking confirmPassword')
            //     if(this.userData.confirmPassword == null) {
            //       errors.push('confirmPassword')
            //     }
            //   }
            //   break
            // case 'confirmPassword':
            //   console.log(v, this.userData.password)
            //   if(this.userData.password != null && v != this.userData.password) {
            //     errors.push('confirmPassword')
            //   }
            //   break
          }
       })
      // sendUser.first_name = this.userData.first_name
      // sendUser.last_name = this.userData.last_name
      // sendUser.email = this.userData.email
      // sendUser.phone = this.userData.phone
      this.errors = errors
      this.$store.commit('setLoading', true)
      console.log(sendUser)
      if(errors.length < 1) {
        let updatedUser = await this.$api.updateMemberProfile(sendUser)
        if(updatedUser) {
          let newUser = JSON.parse(JSON.stringify(this.user))
          newUser.first_name = this.userData.first_name
          newUser.last_name = this.userData.last_name
          newUser.email = this.userData.email
          newUser.phone = this.userData.phone
          this.$store.commit('setActiveUser', newUser)
        }
      }
      this.$store.commit('setLoading', false)
    },
    changeFaveLocation() {
      this.$store.commit('setFaveLocationSelector', true)
    },
    async logOut() {
      // console.log(this.cart)
      if(this.cart) {
        await this.$api.abandonOrder(this.cart.id)
      }
      this.$store.commit('setUserToken', null)
      this.$router.push('/')
      this.$store.commit('setActiveOrder', null)
      // this.$router.push('/signin')
    }
  }
}
